import actions from './moduleMyPeppolReportsActions.js'

export default {
  namespaced: true,
  actions,
}
